import React from 'react';
import { JuniorHubScreen } from '../../components/home/JuniorHubScreen';
import { HERRAMIENTAS_ITEMS } from '../../lib/juniorTheme';

export default function HerramientasHubPage() {
  return (
    <JuniorHubScreen
      eyebrow="Herramientas"
      title="Utilidades musicales"
      subtitle="Metrónomo, afinador y recursos para practicar."
      emoji="🛠️"
      accent="lime"
      items={HERRAMIENTAS_ITEMS}
    />
  );
}
